import { render, staticRenderFns } from "./SafeNotice.vue?vue&type=template&id=244ee7ea&"
import script from "./SafeNotice.vue?vue&type=script&lang=js&"
export * from "./SafeNotice.vue?vue&type=script&lang=js&"
import style0 from "./SafeNotice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports